/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ProblemDetails, ServiceDiscoveryUrls } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetServiceDiscoveryGetUrlsHook = () => {
    const getServiceDiscoveryGetUrls = useCustomInstance<ServiceDiscoveryUrls>();

    return (signal?: AbortSignal) => {
        return getServiceDiscoveryGetUrls({ url: `/ServiceDiscovery/GetUrls`, method: 'get', signal });
    };
};

export const getGetServiceDiscoveryGetUrlsQueryKey = () => [`/ServiceDiscovery/GetUrls`] as const;

export const useGetServiceDiscoveryGetUrlsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetServiceDiscoveryGetUrlsQueryKey();

    const getServiceDiscoveryGetUrls = useGetServiceDiscoveryGetUrlsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>> = ({ signal }) =>
        getServiceDiscoveryGetUrls(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetServiceDiscoveryGetUrlsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>>;
export type GetServiceDiscoveryGetUrlsQueryError = ErrorType<ProblemDetails>;

export const useGetServiceDiscoveryGetUrls = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceDiscoveryGetUrlsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetServiceDiscoveryGetUrlsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
